{
  "error.camp.obligatori": "El camp és obligatori.",
  "error.camp.format": "El format del camp no és vàlid.",
  "error.camp.longitud": "La longitud del camp no és vàlida.",
  "error.id.no.coincideix": "L'identificador de la ruta no coincideix amb el del cos de la petició.",
  "error.permis.denegat": "No tens permís per fer aquesta acció.",
  "error.tenant.invalid": "Només es poden fer servir comptes corporatius de bonÀrea.",
  "error.no.autenticat": "La sessió ha caducat. Torna a iniciar sessió.",
  "error.recurs.no.trobat": "No s'ha trobat el recurs sol·licitat.",
  "error.etag.no.coincideix": "Les dades han canviat des que les vas consultar. Torna-les a carregar.",
  "error.etag.obligatori": "Cal indicar la versió de les dades (capçalera If-Match).",
  "error.activacio.duplicada": "Ja existeix una activació idèntica enviada fa poc.",
  "error.activacio.tancada": "L'activació ja està tancada.",
  "error.activacio.critica.no.permesa": "No tens permís per crear activacions crítiques.",
  "error.activacio.sense.destinataris": "L'activació ha de tenir com a mínim un destinatari.",
  "error.activacio.servei.o.departament": "Cal indicar un servei o un departament.",
  "error.activacio.departament.nomes.it": "Només es pot activar un departament sense servei en guàrdies IT.",
  "error.tancament.motiu": "Cal indicar el motiu del tancament.",
  "error.escalat.ultim.nivell": "L'activació ja és a l'últim nivell d'escalat.",
  "error.activacio.sense.expert": "El servei no té cap tècnic expert disponible per activar.",
  "error.activacio.no.destinatari": "No figures com a destinatari d'aquesta activació.",
  "error.tipusavis.traduccions": "Cal indicar el nom del tipus d'avís en català i en castellà.",
  "error.enviament.sense.contacte": "El destinatari no té cap dada de contacte per a aquest canal.",
  "error.enviament.excepcio": "S'ha produït un error en enviar la notificació.",
  "error.webhook.signatura": "La signatura de la petició no és vàlida.",
  "error.enviament.mailjet": "No s'ha pogut lliurar el correu electrònic.",
  "error.enviament.twilio": "No s'ha pogut completar la trucada de veu.",
  "error.enviament.push": "No s'ha pogut lliurar la notificació push.",
  "error.torn.solapat": "El torn se solapa amb un altre torn del mateix calendari.",
  "error.torn.dates": "La data de fi del torn ha de ser posterior a la d'inici.",
  "error.torn.substitut.igual": "El substitut no pot ser el mateix que el titular.",
  "error.sollicitud.estat": "La sol·licitud ja no es pot modificar en l'estat actual.",
  "error.rotacio.participants": "La rotació necessita com a mínim un participant.",
  "error.rotacio.periode": "El període de la rotació no genera cap torn.",
  "error.calendari.ambit": "El calendari ha de pertànyer a un departament o a una àrea, però no a tots dos.",
  "error.torn.passat": "El torn ja ha finalitzat.",
  "error.sollicitud.proposat": "La persona proposada no pot ser la mateixa que la sol·licitant.",
  "error.sollicitud.titular": "Només el titular del torn pot sol·licitar-ne el canvi.",
  "error.sollicitud.franja": "La nova franja ha d'estar dins del torn original.",
  "error.sollicitud.intercanvi": "El torn d'intercanvi ha de ser del mateix calendari i tenir com a titular la persona proposada.",
  "error.document.format": "El format del fitxer no està permès.",
  "error.document.mida": "El fitxer supera la mida màxima permesa.",
  "error.document.limit": "S'ha arribat al nombre màxim de documents del servei.",
  "error.document.malware": "El fitxer no ha superat l'anàlisi antimalware.",
  "error.document.bloquejat": "El document està bloquejat o retirat.",
  "error.document.retirat": "El document està retirat i no es pot modificar ni descarregar.",
  "error.missatge.mencio": "La menció no correspon a cap persona, servei o departament vàlid.",
  "error.ws.topic": "Cal indicar el canal de temps real.",
  "error.ws.missatge": "El missatge de temps real no és vàlid.",
  "error.import.fitxer": "No s'ha pogut llegir el fitxer d'importació.",
  "error.import.columna": "Falta una columna obligatòria al fitxer d'importació.",
  "error.import.email": "L'adreça de correu no és vàlida.",
  "error.import.duplicat": "L'adreça de correu ja està donada d'alta al servei.",
  "error.import.canal": "El canal indicat no és vàlid.",
  "error.codi.duplicat": "Ja existeix un registre amb aquest codi.",
  "error.circuit.desti": "El nivell d'escalat necessita un destinatari.",
  "error.expert.titular.obligatori": "El servei ha de tenir un tècnic expert titular.",
  "error.expert.duplicat": "La persona ja està assignada com a experta del servei.",
  "error.escalat.ja.notificat": "Aquesta persona ja ha estat avisada en aquesta activació.",
  "error.ambit.id": "Cal indicar l'àrea, el servei o el departament de l'assignació.",
  "error.rol.dates": "La data de fi de l'assignació ha de ser posterior a la d'inici.",
  "error.circuit.defecte.unic": "Només hi pot haver un circuit d'escalat per defecte.",
  "error.circuit.sense.nivells": "El circuit d'escalat ha de tenir com a mínim un nivell.",
  "error.plantilla.variable": "La plantilla conté una variable desconeguda.",
  "error.rol.sistema": "Els rols del sistema no es poden eliminar.",
  "error.integracio.no.disponible": "La integració externa no està disponible en aquest moment.",
  "error.app.versio.minima": "Cal actualitzar l'aplicació a la versió mínima obligatòria.",
  "error.plantilla.tipus": "El tipus de plantilla no és vàlid.",
  "error.plantilla.traduccio": "La plantilla ha de tenir traducció en català i castellà.",
  "error.app.versio": "El número de versió no és vàlid.",
  "error.app.missatge.tipus": "El tipus de missatge administratiu no és vàlid.",
  "error.configuracio.clau": "La clau de configuració no existeix.",
  "error.configuracio.valor": "El valor de configuració no és vàlid.",
  "error.informe.format": "El format d'informe no és vàlid (pdf, csv o xlsx).",
  "error.informe.cron": "L'expressió de programació (cron) no és vàlida.",
  "error.informe.tipus": "El tipus d'informe no és vàlid.",
  "error.peticio.invalida": "La petició no és vàlida.",
  "error.metode.no.permes": "El mètode no està permès.",
  "error.intern": "S'ha produït un error inesperat. Torna-ho a provar més tard.",
  "error.desconegut": "S'ha produït un error inesperat.",
  "error.xarxa": "No es pot connectar amb el servidor.",
  "error.usuari.no.existeix.entra": "Aquest usuari ja no existeix a Entra ID.",
  "error.usuari.camp.no.sincronitzable": "Aquest camp no es pot sincronitzar amb Entra ID.",
  "error.document.no.retirat": "Només es pot restaurar un document retirat.",
  "error.document.restaurar.sense.versio": "El document no té cap versió neta per tornar-lo a publicar.",
  "error.circuit.defecte.inactiu": "El circuit per defecte ha d'estar actiu.",
  "error.usuari.telefon.mobil": "El mòbil ha de tenir 9 dígits i començar per 6 o 7.",
  "error.rol.no.assignable": "No pots assignar un rol amb més permisos que els teus.",
  "error.usuari.ja.existeix": "Aquesta persona ja està donada d'alta al CAI.",
  "error.amb.camp": "{{missatge}} Camp afectat: «{{camp}}».",
  "camp.actiu": "Actiu",
  "camp.activacio": "Activació",
  "camp.adreca": "Adreça",
  "camp.ambit": "Àmbit",
  "camp.ambitId": "Departament, àrea o servei",
  "camp.appVersio": "Versió de l'app",
  "camp.area": "Àrea",
  "camp.areaId": "Àrea",
  "camp.calendari": "Calendari",
  "camp.calendariId": "Calendari",
  "camp.camps": "Camps",
  "camp.canals": "Canals",
  "camp.canalsDefecte": "Canals per defecte",
  "camp.carrec": "Càrrec",
  "camp.categoria": "Categoria",
  "camp.circuit": "Circuit",
  "camp.codi": "Codi",
  "camp.color": "Color",
  "camp.comentari": "Comentari",
  "camp.contacteId": "Contacte",
  "camp.contacteText": "Contacte",
  "camp.critica": "Crítica",
  "camp.cron": "Programació",
  "camp.departament": "Departament",
  "camp.departamentId": "Departament",
  "camp.descripcio": "Descripció",
  "camp.desde": "Des de",
  "camp.destiId": "Destinatari",
  "camp.destinataris": "Destinataris",
  "camp.diaInici": "Dia d'inici",
  "camp.email": "Correu",
  "camp.entraGroupId": "Grup d'Entra ID",
  "camp.entraOid": "Persona d'Entra ID",
  "camp.especialitat": "Especialitat",
  "camp.esperaSeg": "Temps d'espera",
  "camp.experts": "Experts",
  "camp.fi": "Fi",
  "camp.fins": "Fins a",
  "camp.fitxer": "Fitxer",
  "camp.format": "Format",
  "camp.formats": "Formats",
  "camp.fusHorari": "Fus horari",
  "camp.grup": "Grup",
  "camp.horaCanvi": "Hora de canvi",
  "camp.idioma": "Idioma",
  "camp.inici": "Inici",
  "camp.maxDocuments": "Nombre màxim de documents",
  "camp.mencions": "Mencions",
  "camp.mesures": "Mesures",
  "camp.mesuresPendents": "Mesures pendents",
  "camp.midaMaxMb": "Mida màxima",
  "camp.missatge": "Missatge",
  "camp.missatgeFinalitzacio": "Missatge de finalització",
  "camp.motiu": "Motiu",
  "camp.nivells": "Nivells",
  "camp.nom": "Nom",
  "camp.nomCa": "Nom en català",
  "camp.nomEs": "Nom en castellà",
  "camp.notes": "Notes",
  "camp.nouFi": "Nova fi",
  "camp.nouInici": "Nou inici",
  "camp.participants": "Participants",
  "camp.perills": "Perills",
  "camp.periodicitat": "Periodicitat",
  "camp.plantillaId": "Plantilla",
  "camp.proposatId": "Persona proposada",
  "camp.provesRealitzades": "Proves realitzades",
  "camp.recordatoriMinuts": "Recordatori",
  "camp.recurs": "Recurs",
  "camp.ref": "Referència",
  "camp.responsableId": "Responsable",
  "camp.risc": "Risc",
  "camp.rol": "Rol",
  "camp.rolId": "Rol",
  "camp.rotacio": "Rotació",
  "camp.servei": "Servei",
  "camp.serveiId": "Servei",
  "camp.serveiIds": "Serveis",
  "camp.substitutId": "Substitut",
  "camp.tancament": "Tancament",
  "camp.telefon": "Telèfon",
  "camp.tempsConfirmacioSeg": "Temps de confirmació",
  "camp.text": "Text",
  "camp.tipus": "Tipus",
  "camp.tipusAvis": "Tipus d'avís",
  "camp.tipusAvisId": "Tipus d'avís",
  "camp.tipusBase": "Tipus base",
  "camp.tipusDesti": "Tipus de destinatari",
  "camp.titol": "Títol",
  "camp.titularId": "Titular",
  "camp.torn": "Torn",
  "camp.tornId": "Torn",
  "camp.tornIntercanviId": "Torn d'intercanvi",
  "camp.traduccions": "Traduccions",
  "camp.url": "URL",
  "camp.usuari": "Persona",
  "camp.usuariId": "Persona",
  "camp.usuariInformar": "Persona a informar",
  "camp.variables": "Variables",
  "camp.versio": "Versió",
  "camp.versioMax": "Versió màxima",
  "camp.versioMin": "Versió mínima",
  "camp.zona": "Zona",
  "camp.zonaId": "Zona",
  "camp.zonaText": "Zona"
}
